angular.module('impactx.input').controller('CompanyAvatarSelectCtrl', CompanyAvatarSelectCtrl);

CompanyAvatarSelectCtrl.$inject = ['$scope', 'AutocompleteSelectionPanel', '$mdPanel'];

function CompanyAvatarSelectCtrl($scope, AutocompleteSelectionPanel, $mdPanel)
{
    var self = this;

    self.openCompanySelection = function (event) {
        // should not happen anymore but just to be sure
        if (!self.companySelectionIsOpen) {
            var config = {
                uri: $scope.entrypoint,
                parameters: {
                    excludedComId: $scope.selected ? $scope.selected.id : 0
                },
                selected: $scope.selected,
                event: event,
                xPosition: $mdPanel.xPosition.ALIGN_END,
                yOffset: 3,
                target: $scope.target,
                focusSearchInput: true,
                firstLoadOnSearch: true,
                clearOnEmptySearch: true
            };
            self.companySelectionIsOpen = true;
            AutocompleteSelectionPanel.openPanel(config).then(function (selection) {
                $scope.selected = selection;
                if ($scope.onSelect && typeof $scope.onSelect === 'function') {
                    $scope.onSelect({selected: selection});
                }

            }, angular.noop).finally(function () {
                self.companySelectionIsOpen = false;
            });
        }
    };
    
    self.removeSelection = function () {
        delete $scope.selected;
        if($scope.onSelect && typeof $scope.onSelect === 'function'){
            $scope.onSelect();
        }
    }
}